import { createFileRoute, notFound } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { getKeywordToolPage } from '@/components/astro/new-design-25/SEO/keyword-tool-data';
import { KeywordToolSeoPage } from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { pdfToAudioSearch } from '@/lib/pdf-to-audio-search';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/$keywordToolSlug')({
  validateSearch: pdfToAudioSearch,
  beforeLoad: ({ params }) => {
    assertPublicToolsEnabled();
    if (!getKeywordToolPage(params.keywordToolSlug)) {
      throw notFound();
    }
  },
  head: ({ params }) => {
    const page = getKeywordToolPage(params.keywordToolSlug);
    if (!page) return {};

    return {
      meta: [
        ...seo({
          title: page.metaTitle,
          description: page.metaDescription,
        }),
      ],
      links: [
        {
          rel: 'canonical',
          href: normalizeCanonicalUrl(`/${page.slug}`),
        },
      ],
    };
  },
  component: Page,
});

function Page() {
  const { keywordToolSlug } = Route.useParams();
  const page = getKeywordToolPage(keywordToolSlug);
  if (!page) throw notFound();

  return <KeywordToolSeoPage page={page} />;
}
